import { Selectable, SelectableGroup } from '@axa-fr-axion/selectable';
import { Offer as OfferItem } from '../offer';
import { OfferListProps } from './OfferList.interface';
import styles from './offerList.module.css';
import { PropsWithClassName } from 'interfaces';
import { useEffect, useRef } from 'react';

export const OfferList = (data: PropsWithClassName<OfferListProps>): JSX.Element => {
    const { className, offers, value, labelledBy, onChange } = data;
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const recommendedIndex = data.offers.findIndex(formule => formule.isRecommended);
        if (recommendedIndex) {
            containerRef.current?.scrollTo?.({
                left: (containerRef.current?.scrollWidth - window.innerWidth) / 2 * recommendedIndex,
                behavior: 'auto' });
        }
    }, [ data.offers ]);

    return (
        <div ref={ containerRef } className={ className }>
            <SelectableGroup
                className={ styles.container }
                labelledby={ labelledBy }
                value={ value }
                onChange={ onChange }
            >
                { offers.map((offer, index) => (
                    <Selectable
                        className={ styles.selectable }
                        labelledby={ offer.coverageOption?.code }
                        value={ offer.coverageOption?.code }
                        key={ offer.coverageOption?.code }
                    >
                        <OfferItem
                            coverageOption={ offer.coverageOption }
                            tarifMensuel={ offer.tarifMensuel }
                            isRecommended={ offer.isRecommended }
                        />
                    </Selectable>
                )) }
            </SelectableGroup>
        </div>
    );
};
